export { default } from './MfeIconWrapper';
